import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Constants } from './constants';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    var currentUser = this.authService.currentUser();
    var language = localStorage.getItem(Constants.Language);
    if (currentUser != null) {
      if (currentUser && this.authService.getToken()) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authService.getToken()}`,
            ContentType: 'application/json',
            Language: language || 'ko',
            'strcd' : currentUser.stR_CD || '',
            'x-api-key': this.authService.getApiKey(),
          },
        });
      }
    } else {
      request = request.clone({
        setHeaders: {
          Language: language || 'ko',
          ContentType: 'application/json',
          'x-api-key': this.authService.getApiKey(),
        },
      });
    }

    // request = request.clone({
    //   setHeaders: {
    //     Language: language || 'ko',
    //     'x-api-key': this.authService.getApiKey(),
    //   },
    //   withCredentials: true
    // });

    return next.handle(request);
  }
}
